<template>
	<div id="txjl" v-loading="loading">
		<div class="txjl_main">
			<div class="query_info">
				<!-- 订单状态 -->
				<el-select v-model="currOrderType" placeholder="请选择订单状态">
					<el-option v-for="item in orderType" :key="item.value" :label="item.label" :value="item.value" />
				</el-select>
				<!-- 订单编号 -->
				<el-input v-model="orderNum" placeholder="请输入订单编号"></el-input>
				<div class="input-br" />
				<el-date-picker
					v-model="beginDate"
					type="datetime"
					placeholder="开始日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				/>
				<el-date-picker
					v-model="endDate"
					type="datetime"
					placeholder="结束日期"
					class="czdateStyle"
					value-format="yyyy-MM-dd HH:mm:ss"
				/>
				<el-button class="el-button--primary" @click="txCxBtn">查询</el-button>
			</div>
			<div class="czTable">
				<el-table :data="czTableData" border stripe style="width: 100%">
					<el-table-column prop="ApplyTime" label="申请时间" width="170" />
					<el-table-column prop="DmMoney" label="提现金额" />
					<el-table-column prop="StatusText" label="状态">
						<template slot-scope="scope">
							<span v-if="scope.row.StatusText === '待审核'">{{ scope.row.StatusText }}</span>
							<span class="unpaidState" v-if="scope.row.StatusText === '未过审'">{{ scope.row.StatusText }}</span>
							<span class="unpaidState" v-if="scope.row.StatusText === '待出款'">{{ scope.row.StatusText }}</span>
							<span class="payState" v-if="scope.row.StatusText === '已出款'">{{ scope.row.StatusText }}</span>
							<span class="cancelState" v-if="scope.row.StatusText === '已撤销'">{{ scope.row.StatusText }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="Remark" label="备注/说明" />
					<div slot="empty">
						<!-- 表格为空的样式 -->
						<div class="table-empty">
							<img src="@/static/img/zjzh/empty.webp" alt="" />
							<div class="table-empty-text">暂无记录</div>
						</div>
					</div>
				</el-table>
			</div>
			<div class="my-paging" v-show="czTableData.length != 0">
				<div class="everyPageShow">每页显示 10 条</div>
				<div class="totalNum">共{{ paginationArray.total }}条</div>

				<el-pagination
					@current-change="handleCurrentChange"
					:page-size="paginationArray.currpageSize"
					layout="prev, pager, next, jumper"
					:total="paginationArray.total"
					background
				/>
			</div>
		</div>
	</div>
</template>
<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";

export default {
	data() {
		return {
			loading: false,
			// 订单状态
			orderType: [
				{ value: "", label: "请选择" },
				{ value: "1", label: "待审核" },
				{ value: "2", label: "未过审" },
				{ value: "3", label: "待出款" },
				{ value: "4", label: "已出款" },
				{ value: "5", label: "已撤销" },
			],
			currOrderType: "",
			//订单编号
			orderNum: "",
			//日期
			beginDate: "",
			endDate: "",
			//表格数据
			czTableData: [],
			paginationArray: {
				total: 0,
				currpageSize: 10,
				currPage: 1, //当前页数
			},
			//每页展示多少条
			pageSize: [
				{ value: 10, label: "10条" },
				{ value: 20, label: "20条" },
				{ value: 30, label: "30条" },
			],
		};
	},
	mounted() {
		this.initDate();
		this.txCxBtn();
	},
	methods: {
		initDate() {
			let etad = new Date();
			let y = etad.getFullYear();
			let m = ("00" + (etad.getMonth() + 1)).slice(-2);
			let d = etad.getDate();
			let h = etad.getHours();
			d = h > 3 ? d : d - 1;
			this.beginDate = `${y}-${m}-${("00" + d).slice(-2)} 03:00:00`;
			this.endDate = `${y}-${m}-${("00" + (d + 1)).slice(-2)} 03:00:00`;
		},
		//改变分页条数
		pageChange(val) {
			this.paginationArray.currpageSize = val;
			this.txCxBtn();
		},
		//查询
		txCxBtn() {
			let that = this;
			let url = "api/Cash/DrawMoneyApplyList";
			let cxData = {
				EndTime: this.endDate,
				OrderNumber: this.orderNum,
				PIndex: this.paginationArray.currPage,
				PSize: this.paginationArray.currpageSize,
				StartTime: this.beginDate,
				Status: this.currOrderType,
			};
			this.loading = true;
			postAjax(url, cxData)
				.then(data => {
					this.loading = false;
					if (data.IsSucess) {
						that.czTableData = data.Data.rows;
						that.paginationArray.total = data.Data.total;
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		handleCurrentChange(e) {
			//回调为当前跳转的第几页
			this.paginationArray.currPage = e;
			this.txCxBtn();
		},
		//时间格式化
		formatDate(row, column) {
			if (row[column.property]) {
				var arr = row[column.property].split("T");
				var arr1 = arr[1].split(".");
				return arr[0] + " " + arr1[0];
			} else {
				return "-";
			}
		},
	},
};
</script>

<style type="scss">
.txjl_main {
	padding: 20px 0px 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AccountCenter/txjl.vue